import { SystemRole } from '../../utils/roles';

export class User {
  id: string;
  name: string;
  email: string;
  role: SystemRole;

  constructor({
    id,
    name,
    email,
    role
  }: {
    id: string;
    name: string;
    email: string;
    role: SystemRole;
  }) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.role = role;
  }
}
